import { authHeader, handleError } from '../helper';
import APIHelper from "../common/ApiHelper";
import APIURLConstants from "../common/ApiURLConstants";

export const ScoutingCategoryData = {
    getAllScoutingCategoryList,
    insertScoutingCategory,
    updateScoutingCategory,
    updateScoutingCategoryStatus,
    insertScoutingSubCategory,
    updateScoutingSubCategory,
    updateScoutingSubCategoryStatus,
}

function getAllScoutingCategoryList() {
    return APIHelper.get(APIURLConstants.GET_SCOUTING_CATEGORY_LIST, authHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

function insertScoutingCategory(data) {
    return APIHelper.post(APIURLConstants.INSERT_SCOUTING_CATEGORY, data, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function updateScoutingCategory(data) {
    return APIHelper.post(APIURLConstants.UPDATE_SCOUTING_CATEGORY, data, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function updateScoutingCategoryStatus(data) {
    return APIHelper.post(APIURLConstants.UPDATE_SCOUTING_CATEGORY_STATUS, data, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function insertScoutingSubCategory(data) {
    return APIHelper.post(APIURLConstants.INSERT_SCOUTING_SUBCATEGORY, data, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function updateScoutingSubCategory(data) {
    return APIHelper.post(APIURLConstants.UPDATE_SCOUTING_SUBCATEGORY, data, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function updateScoutingSubCategoryStatus(data) {
    return APIHelper.post(APIURLConstants.UPDATE_SCOUTING_SUBCATEGORY_STATUS, data, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}
